const BaseTracker = require('./base');

class YandexTracker extends BaseTracker {
    constructor (locator) {
        super();

        this._window = locator.resolve('window');
        this._config = locator.resolve('config');
        this._logger = locator.resolve('logger');

        /**
         * Вычисленный ключ, по которому в объекте window будет храниться объект
         * яндекса-трекера.
         *
         * @type {String}
         * @private
         */
        this._counterKey = null;

        this._initPromise = new Promise((res) => {
            this._registerTracker(res);
        });
    }

    /**
     * Регистрирование события для яндекс-аналитики
     *
     * Вызывается из BaseTracker
     *
     * @param {Object} data
     * @param {Array} args
     * @private
     */
    _event (data = {}, args) {
        const target = args[0];
        this._window[this._counterKey].reachGoal(target);
    }

    /**
     * Регистрирование показа страницы для яндекс-аналитики
     *
     * Вызывается из BaseTracker
     *
     * @param {*} args
     * @private
     */
    _pageview (...args) {
        this._window[this._counterKey].hit(...args);
    }

    /**
     * Код предоставленный Yandex для подключения аналитика на страницу.
     *
     * @param {function} cb
     * @private
     */
    _registerTracker (cb) {
        const window = this._window;
        const document = this._window.document;

        const beacon = this._config.analytics.yandex.beacon;

        const initYATracker = () => {
            try {
                let key = this._domainConfig(this._config.analytics.yandex.keys);

                this._counterKey = 'yaCounter' + key;

                window[this._counterKey] = new this._window.Ya.Metrika({
                    id: key,
                    clickmap: true, // Карта кликов - шлет кучу левых запросов на любой чих
                    trackLinks: true,
                    accurateTrackBounce: true, // точный показатель отказов
                    webvisor: true
                });
            } catch (e) {
                this._logger.error(new Error('Yandex Analytics init failed'));
            }
        };

        window[beacon] = window[beacon] || [];
        window[beacon].push(initYATracker);
        window[beacon].push(cb);

        const firstScriptNode = document.getElementsByTagName('script')[0];
        const script = document.createElement('script');

        function bindScriptNode () {
            // яндекс.метрика всегда должна быть после гугловой
            let beforeNode = firstScriptNode;
            if (firstScriptNode.src.includes('google')) {
                beforeNode = firstScriptNode.nextSibling;
            }
            firstScriptNode.parentNode.insertBefore(script, beforeNode);
        }

        script.type = 'text/javascript';
        script.async = true;
        script.src = this._config.analytics.yandex.url;

        if (window.opera == '[object Opera]') {
            document.addEventListener('DOMContentLoaded', bindScriptNode, false);
        } else {
            bindScriptNode();
        }
    }
}

module.exports = YandexTracker;



// WEBPACK FOOTER //
// ./services/analytics/trackers/yandex.js